import { getSelectedDivisionId, getSelectedDivisionIdRaw } from './selectedDivisionStorage';

/** Numeric division id for the current tab (0 when unset/invalid). */
export const getDivisionId = (): number => getSelectedDivisionId();

/** Alias used by legacy components. */
export const DivisionId = getDivisionId;

export { getSelectedDivisionIdRaw };
